import { render } from "./Choose.vue?vue&type=template&id=1a0bf1d7&scoped=true"
import script from "./Choose.vue?vue&type=script&lang=js"
export * from "./Choose.vue?vue&type=script&lang=js"

import "./Choose.vue?vue&type=style&index=0&id=1a0bf1d7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0bf1d7"]])

export default __exports__